export const HUMAN_READABLE_DATETIME_FORMAT = "MMM Do YY, h:mm:ss a";
